
export const logo = {
  // Header
  'header.title': 'Logo no Player',
  'header.subtitle': 'Adicione a sua marca ao vídeo e controle posição, tamanho, transparência e link de destino.',
  
  // Toggle
  'enable': 'Ativar Logo',
  'enable.helper': 'Exibe sua logomarca sobre o vídeo.',
  
  // Upload
  'upload.title': 'Upload da Logo',
  'upload.drop': 'Arraste seu arquivo ou clique para enviar',
  'upload.hint': 'PNG com fundo transparente • Máx. 1MB',
  'upload.replace': 'Substituir',
  'upload.remove': 'Remover',
  
  // Link
  'link.title': 'Link',
  'link.set': 'Definir URL',
  'link.none': 'Nenhum link definido.',
  'link.edit': 'Editar',
  'link.remove': 'Remover link',
  'link.openIn': 'Abrir em',
  'link.sameTab': 'Mesma aba',
  'link.newTab': 'Nova aba',
  'link.addUtm': 'Adicionar UTM',
  'link.utmSource': 'utm_source',
  'link.utmMedium': 'utm_medium',
  'link.utmCampaign': 'utm_campaign',
  'link.urlPlaceholder': 'https://exemplo.com',
  'link.error.empty': 'A URL não pode estar vazia',
  'link.error.protocol': 'A URL deve começar com http:// ou https://',
  'link.error.invalid': 'URL inválida',
  
  // Position & Size
  'position.title': 'Posição e Tamanho',
  'position.grid': 'Posição',
  'position.topLeft': 'Superior Esquerda',
  'position.topCenter': 'Superior Centro',
  'position.topRight': 'Superior Direita',
  'position.centerLeft': 'Centro Esquerda',
  'position.center': 'Centro',
  'position.centerRight': 'Centro Direita',
  'position.bottomLeft': 'Inferior Esquerda',
  'position.bottomCenter': 'Inferior Centro',
  'position.bottomRight': 'Inferior Direita',
  
  'size': 'Tamanho',
  'opacity': 'Transparência',
  'offsetX': 'Offset Horizontal',
  'offsetY': 'Offset Vertical',
  
  // Customization
  'customize.title': 'Personalização da Logo',
  'customize.open': 'Personalizar Logo…',
  'customize.border.toggle': 'Adicionar borda',
  'customize.border.color': 'Cor da borda',
  'customize.border.width': 'Espessura',
  'customize.shadow.toggle': 'Adicionar sombra',
  'customize.shadow.color': 'Cor da sombra',
  'customize.shadow.blur': 'Desfoque',
  'customize.shadow.intensity': 'Intensidade',
  'customize.hover': 'Efeito ao passar o mouse',
  'customize.hover.none': 'Nenhum',
  'customize.hover.darken': 'Escurecer 5%',
  'customize.hover.lighten': 'Clarear 5%',
  'customize.hover.scale': 'Aumentar 5%',
  'customize.reset': 'Restaurar padrões',
  
  // Preview badge
  'preview.badge': 'Prévia em Tempo Real',
  'preview.description': 'Todas as alterações são aplicadas instantaneamente.',
  
  // Buttons
  'button.cancel': 'Cancelar',
  'button.save': 'Salvar',
  'button.apply': 'Aplicar',
};
